import { createHelpers } from 'vuex-map-fields'

const { getConfigurationField, updateConfigurationField } = createHelpers({
  getterType: 'getConfigurationField',
  mutationType: 'updateConfigurationField'
})

const state = {
  configuration: {
    form: {
      type: '',
      size: {},
      img: ''
    },
    material: {
      type: '',
      color: {}
    },
    rand: {
    },
    oesenTotal: 0,
    hohlsaum: false,
    drehverschluss: false,
    note: '',
    price: 0,
    quantity: 1
  },
  configurationList: []
}

const mutations = {
  'SET_CONFIG_FORM' (state, formConfig) {
    state.configuration.form.type = formConfig.type
    state.configuration.form.size = {}
    state.configuration.form.size = formConfig.size
    state.configuration.form.img = formConfig.img
  },
  'SET_CONFIG_MATERIAL' (state, materialConfig) {
    state.configuration.material.type = materialConfig.type
    state.configuration.material.color = materialConfig.color
  },
  'SET_CONFIG_RAND' (state, randConfig) {
    state.configuration.rand = {}
    randConfig.forEach(el => {
      state.configuration.rand[el.title] = {}
      state.configuration.rand[el.title].type = el.type.name
      if ('conf' in el) {
        for (const key in el.conf) {
          state.configuration.rand[el.title][key] = el.conf[key]
        }
      }
    })
  },
  'SET_CONFIG_PRICE' (state, price) {
    state.configuration.price = price
  },
  'SET_CONFIG_OESEN_TOTAL' (state, oesen) {
    state.configuration.oesenTotal = oesen
  },
  'SET_CONFIG_HOHLSAUM' (state, activeHohlsaum) {
    state.configuration.hohlsaum = activeHohlsaum
  },
  'SET_CONFIG_DREHVERSCHLUSS' (state, activeDrehverschluss) {
    state.configuration.drehverschluss = activeDrehverschluss
  },
  'CLEAR_CONFIG_PRICE' (state) {
    state.configuration.price = 0
  },
  'CLEAR_CONFIG_NOTE' (state) {
    state.configuration.note = ''
  },
  'CLEAR_CONFIG_OESEN_TOTAL' (state) {
    state.configuration.oesenTotal = 0
  },
  'ADD_CONFIGURATION' (state) {
    state.configurationList.push(JSON.parse(JSON.stringify(state.configuration)))
  },
  'REMOVE_CONFIGURATION' (state, index) {
    state.configurationList.splice(index, 1)
  },
  updateConfigurationField
}

const actions = {
  setConfigForm: ({ commit }, formConfig) => {
    commit('SET_CONFIG_FORM', formConfig)
  },
  setConfigMaterial: ({ commit }, materialConfig) => {
    commit('SET_CONFIG_MATERIAL', materialConfig)
  },
  setConfigRand: ({ commit }, randConfig) => {
    commit('SET_CONFIG_RAND', randConfig)
  },
  setConfigPrice: ({ commit }, price) => {
    commit('SET_CONFIG_PRICE', price)
  },
  setConfigOesenTotal: ({ commit }, oesen) => {
    commit('SET_CONFIG_OESEN_TOTAL', oesen)
  },
  setConfigHohlsaum: ({ commit }, activeHohlsaum) => {
    commit('SET_CONFIG_HOHLSAUM', activeHohlsaum)
  },
  setConfigDrehverschluss: ({ commit }, activeDrehverschluss) => {
    commit('SET_CONFIG_DREHVERSCHLUSS', activeDrehverschluss)
  },
  clearConfigPrice: ({ commit }) => {
    commit('CLEAR_CONFIG_PRICE')
  },
  clearConfigNote: ({ commit }) => {
    commit('CLEAR_CONFIG_NOTE')
  },
  clearConfigOesenTotal: ({ commit }) => {
    commit('CLEAR_CONFIG_OESEN_TOTAL')
  },
  addConfiguration: ({ commit }) => {
    commit('ADD_CONFIGURATION')
  },
  removeConfiguration: ({ commit }, index) => {
    commit('REMOVE_CONFIGURATION', index)
  }
}

const getters = {
  configuration: state => {
    return state.configuration
  },
  configurationList: state => {
    return state.configurationList
  },
  getConfigurationField
}

export default {
  state,
  getters,
  mutations,
  actions
}
